module.exports = __webpack_public_path__ + "img/76800.4073b336.jpg";